import { IExtensionsServerSettings } from '../types/IEditableServerSettings';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetExtensionsServerSettingsParams {
}

export type IGetExtensionsServerSettingsResult = IResult & IExtensionsServerSettings;

export class GetExtensionsServerSettingsRequest extends Request<IGetExtensionsServerSettingsParams, IGetExtensionsServerSettingsResult> {
  constructor(params: IGetExtensionsServerSettingsParams) {
    super('getExtensionsServerSettings', params);
  }
}
